import { defaultTo, map, orderBy } from "lodash";
import { BusinessLineModel, IBusinessLineModel, IModel, ISalesPlanContentModel, ISpeciesModel, Model, SalesPlanContentModel, SpeciesModel } from "@common/models";

export interface ISalesPlanModel extends IModel {
    salesPlanId: number;
    speciesId: number | undefined;
    name: string;
    sortOrder: number | undefined;
    businessLineId: number;
    businessLine: IBusinessLineModel | undefined;
    species: ISpeciesModel | null;
    contents: ISalesPlanContentModel[];
}

export class SalesPlanModel extends Model implements ISalesPlanModel {
    salesPlanId: number;
    speciesId: number | undefined;
    name: string;
    sortOrder: number;
    businessLineId: number;
    businessLine: BusinessLineModel;
    species: SpeciesModel;
    contents: SalesPlanContentModel[] = [];

    constructor(params?: Partial<ISalesPlanModel>) {
        super(params);
        this.salesPlanId = defaultTo(params?.salesPlanId, 0);
        this.speciesId = defaultTo(params?.speciesId, undefined);
        this.name = defaultTo(params?.name, '');
        this.sortOrder = defaultTo(params?.sortOrder, 0);
        this.businessLineId = defaultTo(params?.businessLineId, 0);
        this.businessLine = params?.businessLine ? new BusinessLineModel(params.businessLine) : new BusinessLineModel();
        this.species = params?.species ? new SpeciesModel(params.species) : new SpeciesModel();
        map(orderBy(params?.contents, v => v.sortOrder), (content) => { this.contents.push(new SalesPlanContentModel(content)) });
    }
}
